/**
 * Comparison key of a taxonomy term: NFKD, diacritics stripped, lowercase,
 * whitespace collapsed, trimmed. "Médias", "medias" and " MEDIAS " share one key.
 *
 * Deliberate duplicate of the backend's `normalizeTermKey`
 * (`backend/src/domains/taxonomy/term-normalization.ts`), kept in sync by hand
 * (same precedent as `SUPPORTED_LANG_CODES`): the picker uses it to filter the
 * suggestions instantly and to decide whether "Create «x»" is redundant.
 */
export function normalizeTermKey(rawValue: string): string {
  return rawValue.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/\s+/g, ' ').trim()
}
